import { formatMoney, getStyleChart } from "Helpers/helpFunction";
import moment from "moment";
import imageCircle from '../../../../../assets/images/Common/arount-circle.svg'

export const options = (data: any, handleDetailBranch: any, CommnonStore: any) => {
  return {
    chart: {
      type: 'scatter',
      backgroundColor: 'transparent',
      zoomType: 'xy',
      height: getStyleChart(CommnonStore, 'xuhuong').height,
      spacing: [15, 15, 15, 15],

      events: {
        load: function () {
          const chart: any = this;
          var xAxis = chart.xAxis?.[0]
          var yAxis = chart.yAxis?.[0]
          const width = 450
          let widthScreenFirst = window.innerWidth
          const firstX = xAxis.toPixels(5.7) - (widthScreenFirst > 700 ? width / 2 : width / 4)
          const firstY = yAxis.toPixels(6.1) - (widthScreenFirst > 700 ? width / 2 : width / 4)

          var imageFly = chart.renderer.image(imageCircle, firstX, firstY, width, width)
            .css({ 'z-index': '999' }).add(chart.imggroup);
          setInterval(() => {
            const widthScreen = window.innerWidth
            if (xAxis.series.length > 0 && yAxis.series.length > 0) {
              imageFly.animate({
                x: xAxis.toPixels(5.7) - (widthScreen > 700 ? width / 2 : width / 4),
                y: yAxis.toPixels(6.1) - (widthScreen > 700 ? width / 2 : width / 4),
              }, {
                duration: 300,
                height: 100,
                step: function () {
                  this.attr({
                    zIndex: -1,
                    width: widthScreen > 700 ? width : width / 2,
                    height: widthScreen > 700 ? width : width / 2,
                  })
                },
                complete: function () {
                  this.attr({
                    zIndex: -1,
                    width: widthScreen > 700 ? width : width / 2,
                    height: widthScreen > 700 ? width : width / 2,
                  })
                }
              });
            }
          }, 1000)
        }
      }
    },

    legend: {
      enabled: false
    },

    title: {
      text: ''
    },
    xAxis: {
      min: 0,
      max: 10,
      tickInterval: 0.5,
      labels: {
        enabled: false,
      },
      title: {
        text: ''
      },
      tickLength: 0,
      gridLineWidth: 0.1,
      minorGridLineWidth: 0.2,
      lineWidth: 0,
    },

    yAxis: {
      min: 0,
      max: 10,
      tickInterval: 0.5,
      labels: {
        enabled: false,
      },
      title: {
        text: ''
      },
      gridLineWidth: 0.1,
      minorTickWidth: 0,
    },

    plotOptions: {
      scatter: {
        // stickyTracking: false,
        marker: {
          radius: getStyleChart(CommnonStore, 'xuhuong').point,
          lineWidth: getStyleChart(CommnonStore, 'xuhuong').lineWith,
          // fillColor: '#f7931a',
          // lineColor: '#ffffff',
        },
        dataLabels: {
          enabled: true,
          formatter: function () {
            const thisData: any = this
            return `<div className="omkqutofhd">${thisData?.key}</div>`
          },
          x: getStyleChart(CommnonStore, 'xuhuong').x,
          y: getStyleChart(CommnonStore, 'xuhuong').y,
          z: 0,
          align: 'left',
          useHTML: true,
          verticalAlign: 'left',
          zIndex: -1,
          style: {
            color: '#ffffff',
            textOutline: 'none',
            fontWeight: '300',
            fontSize: getStyleChart(CommnonStore, 'xuhuong').fontSize,
            fontFamily: `Inter`
          }
        },
        events: {
          click: function (item: any) {
            const icbcode = item?.point?.options?.icbcode
            handleDetailBranch('branch', { icbcode: icbcode })
          }
        }
      }
    },
    tooltip: {
      enabled: true,
      useHTML: true,
      borderRadius: 0,
      borderWidth: 0,
      backgroundColor: '#131313',
      className: 'azlsbpynls',
      formatter: function () {
        const thisData: any = this
        const point = thisData?.point?.options

        return `<div class="ioalomryco">
        <div class="fzlgnzcgwl whlqpruvka">Ngày: ${moment().format('DD/MM/YYYY')} </div>
        <div class="fzlgnzcgwl fzbjtfpdgt">Xu hướng ngày: ${moment(point?.tradingDateT5).format('DD/MM/YYYY')} ${formatMoney(thisData.x, 2)}</div>
        <div class="fzlgnzcgwl fzbjtfpdgt">Xu hướng ngày: ${moment(point?.tradingDateT0).format('DD/MM/YYYY')} ${formatMoney(thisData.y, 2)}</div>
        </div>`;
      }
    },
    series: [{
      data: data
    }]
  }
}